// GSAP Animations

( function($) {

  

  window.onload = function(e){  // on load for GSAP


    gsap.registerPlugin(ScrollTrigger);

    console.log("gsap-animations.js ready");


      // RESPONSIVE FUNCTIONS:
      ScrollTrigger.matchMedia({


        // lg destkop:
      "(min-width: 992px)": function() {
        // setup animations and ScrollTriggers for screens 992px wide or greater (bootstrap large) here...
        // The ScrollTriggers created inside these functions are segregated and get reverted/killed when the media query doesn't match anymore. 



      },

      // md-desktop: 
      "(min-width: 768px)": function() {
        // setup animations and ScrollTriggers for screens 768px wide or greater (bootstrap med) here...
        // The ScrollTriggers created inside these functions are segregated and get reverted/killed when the media query doesn't match anymore. 


              // =======================================================
              // ***** DESKTOP: ARTICLE SIDEBAR PINS ******
              // =======================================================
             if( $('.component-article-blog').length ){         
               var pinWrapHeight = $('.js_article--pinwrap').outerHeight(); // wrapper around pinned and unpinned content
               var pinUnpinnedHeight = $('.js_article--unpinned').outerHeight(); // unpinned content height
               var pinElHeight = $('.js_article--pinelement').outerHeight(); // pinned content height
               var pinDuration = pinWrapHeight - pinUnpinnedHeight - pinElHeight; // wrapper minus unpinned minus pinned)
               console.log("pinWrapHeight = " + pinWrapHeight + " | pinUnpinnedHeight = " + pinUnpinnedHeight + " | pinElHeight = " + pinElHeight + " | pinDuration = " + pinDuration + "");
                  ScrollTrigger.create({
                    trigger: ".js_article--pinto",
                    start: "top 45px",
                    // pinDuration calculated above
                    end: self => "+=" + pinDuration,
                    pin: ".js_article--pinelement",
                    markers: false
                  });            
              }
              // ***** END DESKTOP: ARTICLE SIDEBAR PINS ******

        
        
              // =======================================================
              // ***** DESKTOP: FAQ SIDEBAR PINS ******
              // =======================================================
             if( $('.page-faq').length ){    
               /* 
                 NOTE: calculating pin duration ('end' value) as part of scrollTrigger function so it will recalculate when scrolltrigger.refresh is called
                 doing it this way because height of elements changes and scrolltrigger is refreshed whenever an FAQ accordion is clicked
               */
                  ScrollTrigger.create({
                    trigger: ".js_faq-desktop--pinto",
                    start: "top 9px", // padding between top of screen and element
                    end: self => "+=" +  (  ($('.js_faq-desktop--pinwrap').outerHeight()) - ($('.js_faq-desktop--pinelement').outerHeight())  ), // pin duration: (wrapper around pinned content element height) MINUS (pinned content element height) 
                    pin: ".js_faq-desktop--pinelement",
                    markers: false
                  });            
              }
              // ***** END DESKTOP: FAQ SIDEBAR PINS ****** 

      },

        // mobile: 
      "(max-width: 767px)": function() {
 
              // =======================================================
              // ***** MOBILE: STICKY FAQ NAV PIN TO TOP ******
              // =======================================================
             if( $('.page-faq').length ){    
                 ScrollTrigger.create({
                   trigger: ".js_faq-mobile--pinto",
                   start: "top top", 
                   end: "bottom 76px", // 76 = height of mobile nav dropdown
                   pin: ".js_faq-mobile--pinelement",
                   pinSpacing: false, // VERY important for sticky nav like this
                   markers: false
                 });
              }
              // ***** END MOBILE: STICKY FAQ NAV PIN TO TOP ****** 
        
        

      },

      // all 
      "all": function() {
        // ScrollTriggers created here aren't associated with a particular media query,
        // so they persist.

            // =======================================================
            // ***** ALL: PARALLAX IMAGES ******
            // =======================================================
            gsap.utils.toArray(".js_parallax-window").forEach((section, i) => {
              section.bg = section.querySelector(".js_parallax-image"); 
              // Do the parallax effect on each section
                section.bg.style.backgroundPosition = `50% -5vw`,
                gsap.to(section.bg, {
                  backgroundPosition: `50% 5vw`,
                  ease: "none",
                  scrollTrigger: {
                    trigger: section,
                    start: "top 50%", 
                    end: "bottom 50%",
                    scrub: true,
                    markers: false
                  }
                });
            });
            // ***** END ALL: PARALLAX IMAGES ******


      }

    }); 





    }; // end GSAP on load wrapper

  
  

} ) ( jQuery );


$( window ).resize(function() {
  ScrollTrigger.refresh(true);
}); 